import { Fragment, FunctionComponent } from "react";
import { PremiumService, Service } from "@App/types";
import { Checkbox } from "@App/Components/common/Checkbox";
import { useTranslation } from "react-i18next";
import { SubmitButton } from "@App/Components/atoms/whitelabel/home/SubmitButton";
import { PremiumServiceTypes } from "@App/types/enums";
import { TechnicalRepairHint } from "@App/Components/ClientSpecific/Ayvens/TechnicalRepairHint";

type DriverDataServiceStepProps = {
  requiredServices: Service[];
  requiredPremiumServices: PremiumService[];
  optionalServices: Service[];
  optionalPremiumServices: PremiumService[];
  prohibitedServices: Service[];
  prohibitedPremiumServices: PremiumService[];
  togglePremiumService: (premiumService: PremiumService, premiumServices: PremiumService[]) => void;
  premiumServices: PremiumService[];
  services: Service[];
  toggled: (premiumService: PremiumService, premiumServices: PremiumService[]) => boolean;
  serviceToggled: (service: Service | PremiumService) => boolean;
  nextStep: () => void;
  selectService: (service: Service) => void;
  service: Service | null;
};

export const DriverDataServiceStep: FunctionComponent<DriverDataServiceStepProps> = (props) => {
  const { t } = useTranslation();

  const disableNextButton = () => {
    const { premiumServices } = props;
    // True if there is NO sub-service that is NOT "Uvv"
    return !premiumServices.some(
      (ps) => ps.service_type === "sub-service" && ps.type !== PremiumServiceTypes.UVV,
    );
  };

  const isTechnicalRepairSelected = props.premiumServices.some(
    (ps) => ps.type === PremiumServiceTypes.TECHNICAL_REPAIR,
  );

  const prohibitedSubServices =
    props.prohibitedPremiumServices.filter((ps) => ps.service_type === "sub-service") ?? [];

  return (
    <div className="overflow-hidden mb-4 mt-4">
      {(props.requiredServices?.length > 0 || props.requiredPremiumServices?.length > 0) && (
        <Fragment>
          <h3 className={"mb-3 driverdataSubheadlineMandatory"}>{t("driverDataStep.mandatory")}</h3>
          <div className={"driverdataSubheadlineMandatoryHover"}>
            {t("driverDataStep.mandatoryHover")}
          </div>
          {props.requiredServices?.map((service) => (
            <Fragment key={"fragment-" + service.id}>
              <Checkbox
                key={service.id}
                status={props.serviceToggled(service)}
                title={service.name}
                disabled={true}
                onChange={() => {}}
              />
            </Fragment>
          ))}
          {props.requiredPremiumServices?.map((premiumService) => (
            <Fragment key={"fragment-" + premiumService.id}>
              <Checkbox
                key={premiumService.id}
                status={props.toggled(premiumService, props.premiumServices)}
                title={premiumService.name + (premiumService.paid ? "*" : "")}
                disabled={true}
                onChange={() => props.togglePremiumService(premiumService, props.premiumServices)}
              />
            </Fragment>
          ))}
        </Fragment>
      )}
      {(props.optionalServices?.length > 0 || props.optionalPremiumServices?.length > 0) && (
        <Fragment>
          {/*<h3 className={'mb-3 mt-4 driverdataSubheadlineOptional'}>{t('driverDataStep.optional')}</h3>*/}
          {/*<div className={'driverdataSubheadlineOptionalHover'}>{t('driverDataStep.optionalHover')}</div>*/}
          {props.optionalServices?.map((service) => (
            <Fragment key={"fragment-" + service.id}>
              <Checkbox
                key={service.id}
                status={props.serviceToggled(service)}
                title={service.name}
                onChange={() => props.selectService(service)}
              />
            </Fragment>
          ))}
          {props.optionalPremiumServices?.map((premiumService) => (
            <Fragment key={"fragment-" + premiumService.id}>
              <Checkbox
                key={premiumService.id}
                status={props.toggled(premiumService, props.premiumServices)}
                title={premiumService.name + (premiumService.paid ? "*" : "")}
                onChange={() => props.togglePremiumService(premiumService, props.premiumServices)}
              />
            </Fragment>
          ))}
        </Fragment>
      )}
      {(props.prohibitedPremiumServices?.length > 0 || props.prohibitedServices?.length > 0) && (
        <Fragment>
          <h3 className={"mb-3 mt-4 driverdataSubheadlineNotavailable"}>
            {t("driverDataStep.prohibited")}
          </h3>
          <span className={"driverdataSubheadlineNotavailableHover"}>
            {t("driverDataStep.prohibitedHover")}
          </span>

          {props.prohibitedServices?.map((service) => (
            <Fragment key={"fragment-" + service.id}>
              <span className={"font-bold"}>{service.name}</span>
              <br />
            </Fragment>
          ))}
          {prohibitedSubServices.map((premiumService) => (
            <Fragment key={"fragment-" + premiumService.id}>
              <Checkbox
                key={premiumService.id}
                status={props.serviceToggled(premiumService)}
                title={premiumService.name}
                disabled={true}
                onChange={() => {}}
              />
            </Fragment>
          ))}
        </Fragment>
      )}

      {isTechnicalRepairSelected && <TechnicalRepairHint />}

      <SubmitButton text={t("weiter")} disabled={disableNextButton()} onClick={props.nextStep} />
    </div>
  );
};
